import axios from 'axios'
import type { LoginCredentials, LoginResponse, User } from '../types/auth'

class AuthService {
  private token: string | null = null

  constructor() {
    axios.defaults.baseURL = '/api/v1'
    axios.defaults.headers.common['Accept'] = 'application/json'
    axios.defaults.headers.common['Content-Type'] = 'application/json'
    axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

    axios.interceptors.request.use(
      (config) => {
        if (this.token) {
          config.headers.Authorization = `Bearer ${this.token}`
        }
        return config
      },
      (error) => Promise.reject(error)
    )

    axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response?.status === 401) {
          this.setToken(null)
          localStorage.removeItem('token')
          window.location.href = '/login'
        }
        return Promise.reject(error)
      }
    )
  }

  setToken(token: string | null) {
    this.token = token
  }

  async login(credentials: LoginCredentials): Promise<LoginResponse> {
    const response = await axios.post('/auth/login', credentials)
    return response.data.data
  }

  async logout(): Promise<void> {
    await axios.post('/auth/logout')
    this.setToken(null)
  }

  async getCurrentUser(): Promise<User> {
    const response = await axios.get('/auth/user')
    return response.data.data
  }

  async refreshToken(): Promise<string> {
    const response = await axios.post('/auth/refresh')
    return response.data.data.token
  }
}

export const authService = new AuthService()